<template>
  <div>
    <b-card no-body style="" class="mb-1" v-if="menuLoading">
      <b-card-body class="p-md-0">
        <b-spinner variant="'info'" label="Loading..."></b-spinner>
      </b-card-body>
    </b-card>

    <b-card v-else no-body class="py-0 border-top-0 border-left-0 no-top-radius"
            v-for="section in menu.sections" :key="section.id">
      <b-card-header header-tag="header" class="p-0 bg-light" role="tab">
        <b-button
            block
            @click="toggleSection(prefix + section.accordionId, section.id)"
            variant="secondary"
            class="no-glow py-2"
            :id="prefix + section.id"
            :data-test-path="prefix + section.id"
        >

          <!--            @click="$emit('update:openedItem', section.id)"-->
          <div class="section-item" style="position: relative">
            <div v-if="allCount > 0 && section.id === 'm-plm'" class="counterBadge">
              {{ allCount }}
            </div>
            <div class="section-item-icon">
              <font-awesome-icon v-if="section.icon" :icon="section.icon" class="fixed-icon mr-2 "/>
            </div>
            <div class="section-item-label">
              <span>{{ section.label }}</span>
            </div>

          </div>

        </b-button>
      </b-card-header>

      <b-collapse :id="prefix + section.accordionId" v-model="section.open" accordion="menu-accordion" role="tabpanel">
        <div class="bg-light">
          <div v-for="menuItem in section.items" :key="menuItem.id">

            <b-nav-item
                class="nav-link py-0 px-md-0"
                :id="prefix + menuItem.id"
                :data-test-path="prefix + menuItem.id"
                link-classes="text-primary"
                href=""
                v-if="menuItem.hasPermission && !menuItem.items"
                @click="execute(menuItem)">
              <div class="nav-item-inner" style="white-space: normal; position: relative;">
                <div
                    class="counterBadge"
                    v-if="getCounter(menuItem.id) > 0">
                  {{ getCounter(menuItem.id) }}
                </div>
                <div class="nav-item-icon">
                  <font-awesome-icon :icon="menuItem.icon" class="fixed-icon mr-2" />
                </div>
                <div class="nav-item-label">
                  {{ menuItem.label }}
                </div>
              </div>
            </b-nav-item>

            <!--            <sub-menu v-if="menuItem.hasPermission && menuItem.items" :section="menuItem" :parent="self" ref="subMenu">-->
            <!--            </sub-menu>-->

            <sub-menu @run-execute="execute" v-if="menuItem.hasPermission && menuItem.items" :section="menuItem"
                      ref="subMenu">
            </sub-menu>

          </div>
        </div>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>

import {getLeftMenu, openSection} from "@/components/dashboard/menu/MenuContent";
import SubMenu from "@/components/dashboard/menu/SubMenu";
import Dictionary from "@/server/com/silkplm/engine/model/Dictionary";
import {sendEvent} from "@/utils/GEvents";
import Rpc from "@/Rpc";
import FeatureFlag from "@/server/com/silkplm/rpc/FeatureFlag";
import EntitiesList from "@/components/forms/EntitiesList.vue";
import FormsLoader from "@/components/forms/FormsLoader";
import {
  checkIfEnabledByOrganizationFormsSettingsForForm
} from "@/components/forms/customizations/plm/EntityEditFormService";
import Permission from "@/server/com/silkplm/users/Permission";
import Perms from "@/server/Perms";
import RoutingKeys from "@/server/RoutingKeys";

export default {
  name: "MenuItems",
  props: ['type', 'openedItem', 'idPrefix'],
  components: {SubMenu},
  async mounted() {
    let userId = SessionManager.applicationUser.id;
    this.$subscribe(RoutingKeys.UNSEEN_LIST_NOTIFICATION + "." + userId, (val) => {
      this.handleUnseenListNotificationEvent(val, userId)
    });
    this.menuLoading = false;
    this.menu = await getLeftMenu(this.openedItem);
    //open default section
    this.menu.sections.forEach((section) => {
      section.open = openSection(section, this.openedItem);
    });

    this.$onInsert(Dictionary, async () => {
      this.menu = await getLeftMenu(this.openedItem);
    });

    this.$onUpdate(Dictionary, async () => {
      this.menu = await getLeftMenu(this.openedItem);
    });

    this.$onDelete(Dictionary, async () => {
      this.menu = await getLeftMenu(this.openedItem);
    });

    this.$onEvent(Events.menuUpdated, async () => {
      this.menu = await getLeftMenu(this.openedItem);
    });
    await this.loadCountersInMenu();
  },
  methods: {
    checkIfModuleIsEnabled(formClazz) {
      let formConfig = FormsLoader.detectFormConfig(formClazz);
      if (!formConfig) {
        return false;
      }
      let enabled = checkIfEnabledByOrganizationFormsSettingsForForm(formConfig.formId);
      if (!enabled) {
        return false;
      }
      if (formConfig.readPermitted) {
        return true;
      }
      let permissions = [Perms.ALL_BUSINESS_ENTITIES_READ, Perms.SUPERUSER];
      let hasPermission = false;
      for (let perm of permissions) {
        if (SessionManager.hasPermission(perm)) {
          hasPermission = true;
          return false;
        }
      }
      return hasPermission;
    },

    async loadCountersInMenu() {
      if (!FeatureFlag.INTEGRATION_VIEWS) {
        return;
      }
      let result = await Rpc.Users.getCounterDataForViews();
      for (let [counterClass, counter] of Object.entries(result)) {
        let enabled = this.checkIfModuleIsEnabled(counterClass);
        if (enabled) {
          this.counterData.push({counter, counterClass: counterClass.split(".").pop()})
        }
      }
      this.allCount = this.counterData.reduce((sum, item) => sum + item.counter, 0);
    },
    execute(menuItem) {
      if (menuItem.action) {
        Rpc.Interactions.event("left-menu", {name: menuItem.id}).then();
        sendEvent("mnu-clk-" + menuItem.id, {name: menuItem.id});

        menuItem.action();
      }
      if (this.type === 'mobile-menu') {
        this.$parent.hide();
      }
    },

    getCounter(id) {
      const counterObj = this.counterData.find(item => id.includes(item.counterClass));
      return counterObj ? counterObj.counter : 0;
    },

    toggleSection(accordionId, sectionId) {
      this.setOpenedItem(sectionId);
      this.$root.$emit('bv::toggle::collapse', accordionId);
    },

    setOpenedItem(sectionId) {
      sectionId = sectionId.slice(2);
      this.$emit('update:openedItem', sectionId);
    },
    handleUnseenListNotificationEvent(val, sessionUserId) {
      if (!FeatureFlag.INTEGRATION_VIEWS) {
        return;
      }
      if (sessionUserId === val.userId.toString()) {
        let enabled = this.checkIfModuleIsEnabled(val.fullClass);
        if (!enabled) {
          return;
        }
        this.counter = val.counter;
        this.counterClass = val.fullClass.split(".").pop();

        if (this.counter === 0) {
          const existing = this.counterData.find(item => item.counterClass === this.counterClass);
          existing.counter = 0;
          this.allCount = this.counterData.reduce((sum, item) => sum + item.counter, 0);
        } else {
          const existing = this.counterData.find(item => item.counterClass === this.counterClass);

          if (!existing) {
            this.counterData.push({counter: this.counter, counterClass: this.counterClass});
            this.allCount = this.counterData.reduce((sum, item) => sum + item.counter, 0);
          } else {
            existing.counter = this.counter;
            this.allCount = this.counterData.reduce((sum, item) => sum + item.counter, 0);
          }
        }
      }
    }
  },

  // async beforeMount() {
  //   this.menuLoading = false;
  //   this.menu = await getLeftMenu();
  //
  //   if(this.type === 'desktop-menu') {
  //     //on desktop, close all sections
  //     this.menu.sections.forEach((section) => {
  //       section.open = false
  //     })
  //   }
  // },
  data: function () {
    return {
      prefix: this.idPrefix ? this.idPrefix + "-" : "",
      menuLoading: true,
      menu: [],
      self: null,
      counter: 0,
      allCount: 0,
      counterClass: null,
      counterData: [],
    }
  },
}
</script>

<style scoped>
.card {
  border: none !important;
}

.card-header {
  border: none;
}

.btn {
  border-radius: 0;
  border: none !important;
}

.fixed-icon {
  width: 1.5em;
  height: 1.5em;

}

.counterBadge {
  position: absolute;
  top: -5px;
  left: 12px;
  background-color: red;
  color: white;
  font-size: 12px;
  font-weight: bold;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
}
</style>